import { $subscriber, interact } from "fire-wind-water";
import * as sbaseData from "../common/sbase";
import service from "../service/form";
import { $extras, $messageLoad } from "../../stempcore/src/core/sextra.js";

// import settingPC from "@/sktempjson/template-pc.json";
// import settingWAP from "@/sktempjson/template-wap.json";

export default {
  data() {
    return {
      extras: {},
    };
  },
  methods: {
    initConfig() {
      sbaseData.init();
      // if (process.env.NODE_ENV === "development") {
      //   const html = interact.isMobile ? settingWAP.html : settingPC.html;
      //   this.extras = $extras(html).extras;
      //   return;
      // }

      if (!this.tenantId) {
        return;
      }

      if (Object.keys(this.extras).length != 0) {
        return;
      }
      const param = {
        tenantId: this.tenantId,
        configId: !sbaseData.isSetting
          ? this.formInfo.template[interact.isMobile ? "mobile" : "pc"].configId
          : sbaseData.configId,
      };
      service.getTemplateConfig(param).subscribe((res) => {
        if (res.result == 0) {
          if (Object.keys(this.extras).length != 0) {
            return;
          }
          this.extras = $extras(res.content.info.html).extras;
          //this.extras.formfield.model = 'style1'
          // console.log(this.extras.themecolor.bgcolor);

          if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
            let themeColorClear = "";
            const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
            if (rgbaAttr.length >= 3) {
              let r, g, b;
              r = rgbaAttr[0];
              g = rgbaAttr[1];
              b = rgbaAttr[2];
              themeColorClear =
                "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
            }

            document.body.style.setProperty(
              "--themeColor",
              this.extras.themecolor.bgcolor
            );
            document.body.style.setProperty(
              "--themeColorClear",
              themeColorClear
            );
          }
        } else {
          window.$sk.tips.show(res.desc);
        }
      });
    },
  },
  created() {
    sbaseData.init();
    console.log("# subscribe 'sk-template-config'.");
    $subscriber.subscribe("sk-template-config", (o) => {
      console.log("# catch 'sk-template-config' ...");
      // console.log("# o.data: ", JSON.stringify(o.data));
      this.extras = $extras(o.data).extras;

      if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
        let themeColorClear = "";
        const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
        if (rgbaAttr.length >= 3) {
          let r, g, b;
          r = rgbaAttr[0];
          g = rgbaAttr[1];
          b = rgbaAttr[2];
          themeColorClear = "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
        }

        document.body.style.setProperty(
          "--themeColor",
          this.extras.themecolor.bgcolor
        );
        document.body.style.setProperty("--themeColorClear", themeColorClear);
      }
    });
  },
  mounted() {
    console.log("# $messageLoad ...");
    $messageLoad(1);
  },
};
